import standardAPI from '@/api/standard_items';

const responseUrl = '/organisation-tours/tour_operators';

const state = {
  tour_operators: [],
  tour_operators_MetaData: {},
  tour_operators_status: '',
  tour_operators_page: 1,
  tour_operators_perPage: 10,
};

const getters = {
  get_tour_operators: (state) => {
    return state.tour_operators;
  },
  get_tour_operators_status: (state) => {
    return state.tour_operators_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_tour_operators ({ commit }, getOptions) {
    commit('DATA_TOUR_OPERATORS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_TOUR_OPERATORS_UPDATE_SUCCESS', response);
            commit('DATA_TOUR_OPERATORS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_TOUR_OPERATORS_READY');
            reject(response);
          } else {
            commit('DATA_TOUR_OPERATORS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_tour_operators_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_tour_operator ({ commit, dispatch }, itemData) {
    commit('DATA_TOUR_OPERATORS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_TOUR_OPERATORS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_TOUR_OPERATORS_READY');
          reject(response);
        }
      });
    });
  },
  edit_tour_operator ({ commit, dispatch }, itemData) {
    commit('DATA_TOUR_OPERATORS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_TOUR_OPERATORS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_TOUR_OPERATORS_READY');
          reject(response);
        }
      });
    });
  },
  remove_tour_operators ({ commit, dispatch }, itemData) {
    commit('DATA_TOUR_OPERATORS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_TOUR_OPERATORS_REQUEST');
          resolve();
        } else {
          commit('DATA_TOUR_OPERATORS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_tour_operator ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_tour_operator_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.tour_operators_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.tour_operators_perPage = max;
  },
  DATA_TOUR_OPERATORS_READY: (state) => {
    state.tour_operators_status = 'ready';
  },
  DATA_TOUR_OPERATORS_REQUEST: (state) => {
    state.tour_operators_status = 'loading';
  },
  DATA_TOUR_OPERATORS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.tour_operators_MetaData.meta = response.meta;
      state.tour_operators_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.tour_operators = response.data || [];
    }
    state.tour_operators_status = 'success';
  },
  DATA_TOUR_OPERATORS_ERROR: (state) => {
    state.tour_operators_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
